import BusinessManagerRoutes from '@cobliteam/business-manager/src/routes';
import ChecklistsRoutes from '@cobliteam/checklists/src/routes';
import type { Location } from '@cobliteam/common-types';
import EconomicDrivingRoutes from '@cobliteam/economic-driving/src/routes';
import ExpenseRoutes from '@cobliteam/expenses/src/routes';
import GeofencesRoutes from '@cobliteam/geofences/src/routers';
import MaintenanceRoutes from '@cobliteam/maintenance/src/routes';
import MediaRoutes from '@cobliteam/media/src/routes';
import PathAssociationRoutes from '@cobliteam/path-association/src/routes';
import PrismicRoutes from '@cobliteam/prismic/src/routes';
import ProductivityRoutes from '@cobliteam/productivity/src/routes';
import ProofOfConclusionRoutes from '@cobliteam/proof-of-conclusion/src/routes';
import NewReportsRoutes from '@cobliteam/reports/src/routes';
import RoadSpeedRoutes from '@cobliteam/road-speed/src/routes';
import TriggersRoutes from '@cobliteam/triggers/src/routes';
import type React from 'react';
import AIRoutes from './ai';
import BasicValueRoutes from './basic-value';
import ColibShowcaseRoutes from './colib-showcase';
import CommonRouters from './common';
import CrmRoutes from './crm';
import DevicesPage from './devices';
import DriverRoutes from './drivers';
import FinesRoutes from './fines';
import FuelCardRoutes from './fuel-card';
import GroupsRoutes from './groups';
import HomeRoutes from './home';
import IdentifiersRoutes from './identifiers';
import ImagesMatchRoutes from './images-match';
import IntegrationsRoutes from './integrations';
import LivestreamRoutes from './livestream';
import MonitoringRoutes from './monitoring';
import NewsRoutes from './news';
import OperationalSituationRoutes from './operationalSituation';
import PassageHistoryRoutes from './passage-history';
import ReportsRoutes from './reports';
import RoutingRoutes from './routing';
import SafetyDashboardRoutes from './safety-dashboard';
import SafetyRankingRoutes from './safety-ranking';
import SettingsRoutes from './settings';
import SpeedingRoutes from './speeding';
import TrackingRoutes from './tracking';
import TrainingRoutes from './training';
import VehicleRoutes from './vehicles';
export interface IRoute {
  path: Location;
  title?: string;
  // Nested routes inherit this Datadog Team handle so RUM alerts reach the owning squad.
  team?: string;
  featureFlag?: string;
  component?: React.LazyExoticComponent<React.ComponentType<any>>;
  render?: (props: any) => React.ReactNode;
  routes?: IRoute[];
  accessDeniedDescription?: string;
  exact?: boolean;
  hasCameraFlag?: boolean;
  hasRedeCan?: boolean; // hasRedeCan is false when the user has no valid vehicles
  hasGroupsRestriction?: boolean; // hasGroupsRestriction is false when the user has no valid groups or vehicles
  /**
   * Route renders SDUI content that needs @cobliteam/blueprint-react-renderer's
   * context (usePages / <BlueprintRenderer>). PrivateRoute lazily mounts a
   * BlueprintProvider only around these routes so the ~221 KB SDUI runtime
   * doesn't block first paint on the majority of routes that don't use it.
   */
  needsBlueprint?: boolean;
  /**
   * Route renders Google Maps content (maps, markers, autocomplete). PrivateRoute lazily mounts a
   * GoogleMapsProvider (with APIProvider from `@vis.gl/react-google-maps`) only around these routes
   * so the Google Maps JS SDK (~500KB gzipped) doesn't block first paint on the majority of routes
   * that don't use maps.
   */
  needsGoogleMaps?: boolean;
  /**
   * Rota visível só para frotas em onboarding (contrato < 90 dias — AE-2434). PrivateRoute
   * redireciona URL direta para a home quando a frota não está em onboarding (ou quando o
   * status falha).
   */
  requiresOnboardingFleet?: boolean;
}

const routes = [
  ...PrismicRoutes,
  ...BasicValueRoutes,
  ...ChecklistsRoutes,
  ...DevicesPage,
  ...SafetyRankingRoutes,
  ...SafetyDashboardRoutes,
  ...DriverRoutes,
  ...IdentifiersRoutes,
  ...OperationalSituationRoutes,
  ...FuelCardRoutes,
  ...HomeRoutes,
  ...IntegrationsRoutes,
  ...MaintenanceRoutes,
  ...MediaRoutes,
  ...MonitoringRoutes,
  ...PassageHistoryRoutes,
  ...EconomicDrivingRoutes,
  ...ProductivityRoutes,
  ...ReportsRoutes,
  ...NewReportsRoutes,
  ...RoutingRoutes,
  ...SettingsRoutes,
  ...SpeedingRoutes,
  ...TrackingRoutes,
  ...VehicleRoutes,
  ...CommonRouters,
  ...TriggersRoutes,
  ...ProofOfConclusionRoutes,
  ...CrmRoutes,
  ...BusinessManagerRoutes,
  ...TrainingRoutes,
  ...LivestreamRoutes,
  ...RoadSpeedRoutes,
  ...ExpenseRoutes,
  ...PathAssociationRoutes,
  ...ImagesMatchRoutes,
  ...GroupsRoutes,
  ...NewsRoutes,
  ...AIRoutes,
  ...ColibShowcaseRoutes,
  ...FinesRoutes,
  ...GeofencesRoutes,
];

export default routes;
